
export function getZoomForRadius(radius: number, desiredPixelsBetweenPoints?: number) {
    return Math.ceil(Math.log2((360.0 * ((desiredPixelsBetweenPoints??60) / 2.0)) / (256 * radius)));
}